import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateDistributors } from '../../store/ducks/tables/actions';

export default function useGetDistributors() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(page?: number, rowsPerPage?: number) {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/distributors', {
        params: {
          rowsPerPage: rowsPerPage || 20,
          page: page,
        },
      });

      if (response.status === 200) {
        dispatch(populateDistributors(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
